import { RadioModel } from '../shared/controls/radio-group/typings/radio';

import brakeIcon      from 'icons/brake-primary.svg';
import caravanIcon    from 'icons/caravan-primary.svg';
import suspensionIcon from 'icons/suspension-primary.svg';
import tireIcon       from 'icons/tire-primary.svg';

type WorkshopTypeIcon = Pick<RadioModel, 'icon' | 'iconTheme'>;

// Auto mechanical and any type not listed below use this one.
export const WORKSHOP_TYPE_DEFAULT_ICON : WorkshopTypeIcon = { icon: 'workshops' };

export const WORKSHOP_TYPE_ICONS : { [ code : string ] : WorkshopTypeIcon } = {
  AUTO_ELECTRICIANS               : { icon: 'electrician' },
  BICYCLE_REPAIRERS               : { icon: 'bicycle' },
  BRAKE_AND_CLUTCH                : { icon: brakeIcon, iconTheme: 'inline' },
  CARAVAN_RV_REPAIRERS            : { icon: caravanIcon, iconTheme: 'inline' },
  FARM_MACHINERY_REPAIRERS        : { icon: 'tractor' },
  MARINE_AND_BOAT_REPAIRERS       : { icon: 'boat' },
  MOTORCYCLE_AND_SCOOTER_REPAIRERS: { icon: 'motorcycle' },
  SUSPENSION_SPECIALISTS          : { icon: suspensionIcon, iconTheme: 'inline' },
  TRUCK_REPAIRERS                 : { icon: 'truck' },
  TYRE_OUTLETS                    : { icon: tireIcon, iconTheme: 'inline' }
};
